module.exports = __webpack_public_path__ + "img/c05.ca2ce79d.png";